import React from 'react'
import { useTranslation } from 'react-i18next'

import bigStar from 'src/assets/icons/big-yellow-star.svg'
// import Detail from './components/Detail/Detail'

import { formattedText } from 'src/utils/formattedText'
import { useGlobalStore } from 'src/zustand/providers/global-store-provider'

import styles from './UserBalance.module.scss'

interface Props {
  className?: string
}

const UserBalance: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation()
  const balanceStars = useGlobalStore((state) => state.user?.balance_stars)

  if (!balanceStars) {
    return null
  }

  const formattedBalance = formattedText(Number(balanceStars?.toFixed(2)))

  return (
    <div className={styles.balance}>
      <div className={styles.icon}>
        {/* <Icon name='big_yellow_star' /> */}
        <img src={bigStar} alt='Big yellow star' />
      </div>

      <div className={styles.info}>
        <p className={styles.label}>{t('main_page.total_balance')}</p>
        <h1>{`${formattedBalance} ${t('main_page.stars')}`}</h1>

        {/* <pre>{initData}</pre> */}

        {/* <div className={styles.header_details}>
          <Detail amount={1000000.45} text={t('main_page.pending')} variant='pending' />
          <Detail amount={1000000.45} text={t('main_page.available')} variant='available' />
        </div> */}
      </div>
    </div>
  )
}

export default UserBalance
